module.exports = __webpack_public_path__ + "img/electric-mining-drill-S-drill-received-shadow.98fe9ebe.png";